<template>
	<footer id="footer" class="app-footer">
		<div
			class="app-footer-content d-flex flex-column flex-sm-row gap-1 justify-content-between"
		>
			<span>{{
				$t('footer.copyright' /* 版權資訊 */, { year: currentYear })
			}}</span>
			<span class="d-none d-sm-inline text-sm-end">
				{{
					$t('footer.powered_by' /* 技術提供 */).replace(
						providerName,
						''
					)
				}}<a
					:href="providerUrl"
					class="text-reset"
					target="_blank"
					rel="noopener noreferrer"
					>{{ providerName }}</a
				>
			</span>
		</div>
	</footer>
</template>

<script setup>
const currentYear = new Date().getFullYear();
const providerName = 'YourSaaS.com';
const providerUrl = 'https://www.yoursaas.com';
</script>
